// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CYPZ","colMin":"styles_colMin__C94gi"};